/**
* Created by dinesh on 13/6/17.
*/
import {Component, OnInit, AfterContentChecked} from '@angular/core';
import {AngularTokenService} from '@lakshvairav/angular-token';
import {Router} from '@angular/router';
import {AuthorizationService} from '../../shared/authorization.service';
import {KeyValue} from '../../shared/key-value';
declare function init_input_check(): void;

@Component({
  selector: 'app-change-pwd',
  templateUrl: 'change-pwd.component.html'
})
export class ChangePasswordComponent implements OnInit, AfterContentChecked {
  username: string = '';
  email: string;
  newpassword: any;
  newpasswordconfirm: any;
  oldpassword: any;
  errorMsg: string;
  Msg: string;
  enableLayoutMenu: boolean = false;
  enableCancel: any;
  homePath: any;
  constructor(private router: Router, private _tokenService: AngularTokenService,
    public authService: AuthorizationService) {
    this.homePath = this.authService.homePath();
    this.enableLayoutMenu = this.authService.canEnableLayoutMenu();
    this.enableCancel = this.authService.init_pwd_changed
  }

  ngOnInit() {
    if (this.authService.licenceRejected) {
      this.router.navigate([KeyValue.licencePath]);
    }
    setTimeout(function() {
      init_input_check();
    }, 1000);
    // if (this.authService.init_pwd_changed==true){
    //   this.router.navigate([KeyValue.allPath]);
    // }
  }

  ngAfterContentChecked() {
    if (this._tokenService.currentUserData != null) {
      this.username = this._tokenService.currentUserData.uid;
    }
  }

  allowPassword() {
    this.router.navigate(['/change-password-submit']);
  }
  
  HomePage() {
    this.router.navigate([this.homePath])
  }

  deneyPassword(error) {
    console.log(error)
    const error_length =error.error.errors.full_messages.length
    this.errorMsg = error.error.errors.full_messages[error_length-1];
  }

  updatePasssword() {
    this.errorMsg = ''
    if (this.newpassword == undefined || this.newpasswordconfirm == undefined || this.oldpassword == undefined || this.newpassword == '' || this.newpasswordconfirm == '' || this.oldpassword == '') {
      // if (this.oldpassword == undefined){
      //   this.errorMsg = "current password can not be left blank"
      // }
      // else if (this.newpassword == undefined){
      //   this.errorMsg = "new password can not be left blank."
      // }
      // else {
      //   this.errorMsg = "confirmation password can not be left blank"
      // }
      this.errorMsg = "Please fill all the fields"
    } else {
      this._tokenService.updatePassword({
        password: this.newpassword,
        passwordConfirmation: this.newpasswordconfirm,
        passwordCurrent: this.oldpassword
      }).subscribe(
        () => {
          this.authService.passwordChanged();
          this.allowPassword();
        },
        error => {
          this.deneyPassword(error);
        }
        );
    }
  }


  logout(): void {
    //event.preventDefault();
    this._tokenService.signOut().subscribe(
      () => {
        this.router.navigate(['/sign-in']);
      },
      error => console.log(error)
    );
  }

  revealPassword(id, image_id) {
    const element = (document.getElementById(id) as HTMLInputElement);
    if (element.type === 'password') {
      element.type = 'text';
      (document.getElementById(image_id) as HTMLInputElement).src = 'assets/images/eye.svg';
    }else {
      element.type = 'password';
      (document.getElementById(image_id) as HTMLInputElement).src = 'assets/images/eye_password.svg';
    }
  }
}
